import {
    Button,
    Dropdown,
    InputPlaceholder,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/platform/ui';
import { Deferred, useForm, usePage } from '@inertiajs/react';

const AttachOfficeContactModal = ({ onClose }) => {
    const { auth, attachable_office_contacts } = usePage().props;
    const { data, setData, post, errors, processing } = useForm({
        office_contact_id: '',
    });

    const handleSubmit = () => {
        post(`/customers/${auth.customer.id}/office-contacts`, {
            preserveScroll: true,
            onSuccess: () => onClose(),
        });
    };

    return (
        <Modal open={true} onClose={onClose} size='medium'>
            <ModalHeader>Bestaande contactpersoon koppelen</ModalHeader>
            <ModalContent>
                <Deferred
                    data={['attachable_office_contacts']}
                    fallback={
                        <InputPlaceholder
                            label='Contactpersoon'
                            placeholder='Contactpersonen worden geladen...'
                        />
                    }
                >
                    <Dropdown
                        label='Contactpersoon'
                        description='Nieuwe contactpersonen van de overheid maak je aan via VCSW > Contactpersonen.'
                        required
                        value={data.office_contact_id}
                        options={attachable_office_contacts?.map(contact => ({
                            id: contact.id,
                            name: [
                                contact.name,
                                contact.organisation,
                                contact.office,
                            ]
                                .filter(Boolean)
                                .join(' - '),
                        }))}
                        onChange={value => setData('office_contact_id', value)}
                        error={errors?.office_contact_id}
                    />
                </Deferred>
            </ModalContent>
            <ModalActions>
                <Button onClick={onClose}>Annuleren</Button>
                <Button
                    variant='primary'
                    onClick={handleSubmit}
                    loading={processing}
                >
                    Koppelen
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default AttachOfficeContactModal;
